import React, { useEffect, useState } from "react";
import Dropdown from "./DropDown";
import GameCard from "./header/GameCard";
import { MOBILE_MAX_WIDTH_PX } from "../util/Constant";

interface Card {
  label: string;
  icon: string;
  isDisable?: boolean;
}

interface DropCardViewProps {
  cards: Array<Card>;
  selectedCard: string | null;
  onCardClick: (option: any) => void;
}

const DropCardView: React.FC<DropCardViewProps> = ({
  cards,
  selectedCard,
  onCardClick,
}) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < MOBILE_MAX_WIDTH_PX
  );
  const [preSelected, setPreSelected] = useState<string | null>(selectedCard);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_MAX_WIDTH_PX);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setPreSelected(selectedCard);
  }, [selectedCard, isMobile]);

  return (
    <>
      {isMobile ? (
        <Dropdown
          label={preSelected || "Joker Games"}
          options={cards.filter((card) => !card.isDisable)}
          onSelect={(option) => {
            setPreSelected(option);
            onCardClick(option);
          }}
        />
      ) : (
        cards
          .filter((card) => !card.isDisable)
          .map((card) => (
            <GameCard
              key={card.label}
              label={card.label}
              highlight={preSelected === card.label}
              icon={card.icon}
              onClick={() => {
                setPreSelected(card.label);
                onCardClick(card);
              }}
              isFilterApplied
            />
          ))
      )}
    </>
  );
};

export default DropCardView;
